import template from './ws-two-part-allocation-bar.tmpl.html';

export default function TwoPartAllocationBarDirective() {
  return {
    restrict: 'E',
    scope: {
      // Width of the progress bar (value should be 0 - 100)
      widthPercent: '@',
      // Title to show above progress bar
      titleLeft: '@',
      titleRight: '@',
      // Text to show within progress bar
      textLeft: '@',
      textRight: '@',
    },
    template,
  };
}



// WEBPACK FOOTER //
// ./src/two-part-allocation-bar/ws-two-part-allocation-bar.directive.js